import { createContext, useContext, useCallback, useReducer } from "react";
import useResetableStorage, {
  STORAGE_KEY_PREFIX,
} from "app/utils/useResetableStorage";
import {
  INITIAL_STATE,
  scoreReducer,
  type ScoreAction,
  type ScoreState,
} from "app/score/scoreState";

export function useScoreReducer() {
  const serializer = (state: ScoreState): string => JSON.stringify(state);
  const deserializer = (value: string): ScoreState => JSON.parse(value);

  const [savedState, setSaveState] = useResetableStorage(
    `${STORAGE_KEY_PREFIX}_SCORE`,
    INITIAL_STATE,
    { raw: false, serializer, deserializer },
  );

  const reducerLocalStorage = useCallback(
    (state: ScoreState, action: ScoreAction) => {
      const newState = scoreReducer(state, action);
      setSaveState(newState);
      return newState;
    },
    [setSaveState],
  );

  return useReducer(reducerLocalStorage, savedState || INITIAL_STATE);
}

export const ScoreDispatchContext = createContext<React.Dispatch<ScoreAction>>(
  () => {},
);

export function useScoreDispatch() {
  return useContext(ScoreDispatchContext);
}

export const ScoreContext = createContext<ScoreState>(INITIAL_STATE);

export function useScoreState() {
  return useContext(ScoreContext);
}
